export type AiModelPreference = "regular" | "premium";

export function normalizeAiModelPreference(
  aiModel: string | null | undefined,
): AiModelPreference {
  if (aiModel === "premium" || aiModel === "opus") return "premium";
  return "regular";
}

export function isPremiumAiModel(aiModel: string | null | undefined): boolean {
  return normalizeAiModelPreference(aiModel) === "premium";
}

